export default __webpack_public_path__ + "static/media/icn-agent.218b5e16.svg";